const DEFAULT_LANGUAGE_CODE = 'en'

export const normalizeAutocompleteLanguageCode = (
	languageCode: string
): string => {
	const normalizedLanguageCode = languageCode.trim().toLowerCase()

	if (normalizedLanguageCode === '') {
		return DEFAULT_LANGUAGE_CODE
	}

	const [baseLanguageCode] = normalizedLanguageCode.split('-')
	return baseLanguageCode || DEFAULT_LANGUAGE_CODE
}
